angular.module("Main").factory("AuthInterceptor", ["$q", "$state", function ($q, $state) {
    return {
        responseError: responseError
    };

    function responseError(response) {
        if (response.status === 403) {
            $state.go("no_access",{urlIncomplete: 1});
        }

        return $q.reject(response);
    }
}]);